(()=>{
  const media=window.matchMedia('(min-width:901px)');
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
  const eligible=()=>media.matches && (!reduce.matches||document.documentElement.classList.contains('v13-force-motion')) && document.body?.dataset.v12Light!=='false';
  const targets=['.v8-hero','.v9-chamber__scene','.sig-viewer'];
  const attach=()=>{
    if(!eligible())return;
    targets.forEach(selector=>{
      document.querySelectorAll(selector).forEach(el=>{
        if(el.dataset.v12Lit)return;
        el.dataset.v12Lit='true';
        let raf=0,x=50,y=50;
        const apply=()=>{raf=0;el.style.setProperty('--v12-light-x',x+'%');el.style.setProperty('--v12-light-y',y+'%')};
        const move=e=>{
          if(e.pointerType==='touch'||!eligible())return;
          const box=el.getBoundingClientRect();
          if(!box.width||!box.height)return;
          x=Math.max(0,Math.min(100,Math.round((e.clientX-box.left)/box.width*100)));
          y=Math.max(0,Math.min(100,Math.round((e.clientY-box.top)/box.height*100)));
          el.classList.add('v12-lit');
          if(!raf)raf=requestAnimationFrame(apply);
        };
        const leave=()=>{el.classList.remove('v12-lit');if(raf){cancelAnimationFrame(raf);raf=0}};
        el.addEventListener('pointermove',move,{passive:true});
        el.addEventListener('pointerleave',leave,{passive:true});
      });
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',attach,{once:true});else attach();
  document.addEventListener('shopify:section:load',attach);
  document.addEventListener('buton:motion-change',attach);
  media.addEventListener?.('change',attach);
  reduce.addEventListener?.('change',attach);
})();
